<template>
  <div class="card">
    <div
      v-for="(itemService, itemServiceIndex) in itemServices"
      :key="itemService.id"
      class="card-section hover"
    >
      <div
        class="title"
        :class="highlightDeleteChange(itemService.addendumLabel) || highlightNonDeleteTitleChange(itemService, itemServiceIndex)"
      >
        {{ itemService.title }}
      </div>
      <div
        v-if="itemService.sectionDesc"
        class="description"
        :class="highlightDeleteChange(itemService.addendumLabel) || highlightNonDeleteChange(itemService.addendumLabel)"
      >
        <pre><p>{{ itemService.sectionDesc || '' }}</p></pre>
      </div>
      <table>
        <thead>
          <th class="number">
            #
          </th>
          <th style="padding-left: 0;">
            {{ $t('tender.section.descOfWork') }}
          </th>
          <th class="qty-text">
            {{ $t('tender.section.qty') }}
          </th>
          <th class="unit-text">
            {{ $t('tender.section.unit') }}
          </th>
        </thead>
        <tbody>
          <template v-for="(item, index) in itemService.lineItems">
            <tr
              :key="item.id"
              class="set-border-top"
              :class="highlightDeleteChange(itemService.addendumLabel, item.addendumLabel) || highlightNonDeleteLineChange(item, itemServiceIndex, index)"
              :style="setBackgroundColor(index)"
            >
              <td class="number">
                {{ item.itemNo }}
              </td>
              <td class="desc-of-work-text">
                <pre class="none-x-scroll"><p>{{ item.itemDesc }}</p></pre>
              </td>
              <td class="qty-text">
                {{ item.itemQty }}
              </td>
              <td class="unit-text">
                {{ item.itemUnit }}
              </td>
            </tr>
            <tr
              v-for="(option, optionIndex) in item.options"
              :key="optionIndex"
              :class="highlightDeleteChange(itemService.addendumLabel, item.addendumLabel, option.addendumLabel) || highlightNonDeleteChange(option.addendumLabel)"
              :style="setBackgroundColor(index)"
            >
              <td />
              <td
                class="option-desc"
                :style="setPaddingBottom(optionIndex, item.options)"
              >
                <pre><p>{{ option.optionDesc }}</p></pre>
              </td>
              <td
                class="qty-text"
                :style="setPaddingBottom(optionIndex, item.options)"
              >
                {{ option.optionQty }}
              </td>
              <td
                class="unit-text"
                :style="setPaddingBottom(optionIndex, item.options)"
              >
                {{ option.optionUnit }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <div
      v-if="showOthersForEngineer"
      class="row card-section hover"
    >
      <input
        class="section-others-checkbox"
        type="checkbox"
        disabled
        :checked="allowServiceAddOthers"
      >
      <div
        class="title"
        :class="highlightAllowServiceAddOthers"
      >
        {{ $t('tender.section.unExternalOthers') }}
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapState, mapGetters } from 'vuex'
import { addendumChangeType } from '@/utils/locale'
import { getAllowServiceAddOthersUpdated, getHighlightAllowServiceAddOthers } from '@/utils/tenderUtils'

export default {
  name: 'ItemsServicesView',
  computed: {
    ...mapState('tenders', {
      itemServices (state) {
        // service without checked:itemService Item, with checked true: optional, with checked false: optional unchecked
        return state.currentTender.service.filter(service => service.checked !== false)
      },
      addendumClassName (state) {
        return state.addendumClassName
      },
      revisionHistory (state) {
        return state.recentRevisionHistory
      },
    }),
    ...mapGetters('tenders', [
      'isAddendum',
      'currentTender',
    ]),
    allowServiceAddOthers () {
      return lodash.get(this.currentTender, 'general.allowServiceAddOthers') || false
    },
    showOthersForEngineer () {
      return this.allowServiceAddOthers || getAllowServiceAddOthersUpdated(this.currentTender)
    },
    highlightAllowServiceAddOthers () {
      return getHighlightAllowServiceAddOthers({
        isAddendum: this.isAddendum,
        currentTender: this.currentTender,
      })
    },
  },
  methods: {
    setBackgroundColor (index) {
      return (index % 2 === 1) ? 'background-color: #ffffff;' : 'background-color: #f9f9f9;'
    },
    setPaddingBottom (index, options) {
      return (index + 1 === options.length) ? 'padding-bottom: .5rem;' : ''
    },
    highlightDeleteChange (...updatedLabels) {
      if (!this.isAddendum) return ''
      const matched = updatedLabels.filter(label => label && label.startsWith(addendumChangeType.removed))
      return matched.length > 0 ? `${this.addendumClassName}-${addendumChangeType.removed}` : ''
    },
    highlightNonDeleteChange (updatedLabel) {
      if (!this.isAddendum || (updatedLabel && updatedLabel.startsWith(addendumChangeType.removed))) return ''
      return updatedLabel ? `${this.addendumClassName}-${updatedLabel}` : ''
    },
    highlightNonDeleteTitleChange (item, itemServiceIndex) {
      if (!this.isAddendum || !lodash.get(this.revisionHistory, `service.data[${itemServiceIndex}].title`, '')) return ''
      return item.addendumLabel ? `${this.addendumClassName}-${item.addendumLabel}` : ''
    },
    highlightNonDeleteLineChange (item, itemServiceIndex, lineIndex) {
      if (!this.isAddendum || !lodash.get(this.revisionHistory, `service.data[${itemServiceIndex}].lineItems[${lineIndex}]`, '')) return ''
      return item.addendumLabel ? `${this.addendumClassName}-${item.addendumLabel}` : ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/tender/edit';
@import '~styles/tender/itemServices';
@import '~styles/tender/addendum';

.none-x-scroll {
  -ms-overflow-x: hidden;
  overflow-x: hidden;
}
.section-others-checkbox {
  margin: 10px 10px 0 0;
}
</style>
